import { investorActions, investorReducer } from '@/store/investor';
import { adminApi, adminKYCApi, investorApi, kycApi } from '@/api';
import { entitiesActions } from '@/store/entities';
import { calcAdditionalInfo, formatInvestorObject } from '@/utils/helpers/investor';
import { userActions } from '@/store/user';
import { getErrorMessage } from '@/utils/helpers';

export const setInvestor = (investor) => async (dispatch) => {
  dispatch(investorReducer.setInvestor(investor));
};

export const getInvestor =
  (mainOnly = false) =>
  async (dispatch) => {
    try {
      const resInvestor = await investorApi.getInvestor();

      if (resInvestor.status === 200) {
        const investorObject = formatInvestorObject(resInvestor.data);
        dispatch(investorReducer.setInvestor(investorObject));
        dispatch(userActions.setEmail(investorObject.email));
      }

      if (resInvestor?.data?.accountStatus !== 'NOT_ACTIVE') {
        const sumSubStatusRes = await kycApi.getSumSubStatus();
        if (sumSubStatusRes && sumSubStatusRes.data) {
          if (
            sumSubStatusRes.data.myStatus === 'Accepted' ||
            sumSubStatusRes.data.myStatus === 'In process'
          ) {
            dispatch(investorActions.setIsUserVerified(true));
          }
        }
      }

      const resCitizenship = await investorApi.getCitizenship();
      if (resCitizenship.status === 200) {
        dispatch(investorReducer.setCitizenship(resCitizenship.data[0]));
      }

      // dispatch(getAdditionalInfo());

      return resInvestor.data;
    } catch (e) {
      console.error(e);
      dispatch(entitiesActions.addToastError(getErrorMessage(e)));
    }
  };
export const getAdditionalInfo = () => async (dispatch) => {
  try {
    const resQuestId = await investorApi.getAdditionalInfoQuestId();
    const resQuest = await kycApi.getQuestionnaireSections(resQuestId?.data?.id);
    const additionalInfo = calcAdditionalInfo(resQuest.data);
    if (additionalInfo) dispatch(investorReducer.setAdditionalInfo(additionalInfo));
  } catch (e) {
    console.error(e);
    dispatch(entitiesActions.addToastError(getErrorMessage(e)));
  }
};

export const setVerifiedEmail = (verified) => async (dispatch) => {
  dispatch(investorReducer.setVerifiedEmail(verified));
};

export const resetInvestor = () => async (dispatch) => {
  dispatch(investorReducer.resetInvestor());
};

export const fetchInvestorProfile = (id, dispatch) => {
  return new Promise(async (resolve, reject) => {
    try {
      const resInvestor = await adminApi.getInvestor(id);
      const investorObject = formatInvestorObject(resInvestor.data);
      dispatch(investorReducer.setInvestor(investorObject));

      const resCitizenship = await adminApi.getInvestorCitizenship(id);
      dispatch(investorReducer.setCitizenship(resCitizenship.data[0]));

      // await getInvestorAdditionalInfo(id, dispatch);

      // const {data} = await adminKYCApi.getDeepCheckStatuses();
      // if (data) {
      //   dispatch(investorReducer.set)
      // }

      resolve(investorObject);
    } catch (e) {
      console.error(e);
      dispatch(entitiesActions.addToastError(getErrorMessage(e)));
      reject();
    }
  });
};

export const fetchProfile = (dispatch) => {
  return new Promise(async (resolve, reject) => {
    try {
      const resInvestor = await investorApi.getInvestor();
      const investorObject = formatInvestorObject(resInvestor.data);
      dispatch(investorReducer.setInvestor(investorObject));

      const resCitizenship = await investorApi.getCitizenship();
      dispatch(investorReducer.setCitizenship(resCitizenship.data[0]));

      resolve();
    } catch (e) {
      console.error(e);
      dispatch(entitiesActions.addToastError(getErrorMessage(e)));
      reject();
    }
  });
};

export const setInvestorParams = (params) => (dispatch) => {
  dispatch(investorReducer.setInvestor(params));
};
const getInvestorAdditionalInfo = (id, dispatch) => {
  return new Promise(async (resolve, reject) => {
    try {
      const resQuestId = await adminApi.getInvestorAddInfoQuestId(id);
      const resQuest = await adminKYCApi.getQuestionnaireAnswers({
        investorId: id,
        questionnaireId: resQuestId?.data?.id
      });
      const additionalInfo = calcAdditionalInfo(resQuest.data);
      dispatch(investorReducer.setAdditionalInfo(additionalInfo));

      resolve();
    } catch (e) {
      console.error(e);
      dispatch(entitiesActions.addToastError(getErrorMessage(e)));
      reject();
    }
  });
};

export const setIsUserVerified = (state) => (dispatch) => {
  dispatch(investorReducer.setIsUserVerified(state));
};
